import { Component, OnInit, ViewEncapsulation, ViewChild, ChangeDetectorRef, OnDestroy, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UtilityService, AuthenticationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import {
  ProductModel, SEO
} from '../../models';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { TAB, BREADCRUMBS, PRODUCT_CONFIG, PREMIER_AUTHFAILURE_MESSAGE, ENV } from 'config';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';
import { DomSanitizer } from '@angular/platform-browser';
import { MOBILEPIVOTS } from 'config';
import { CMSResolver } from 'lib/ng2-sapmp/src/providers/cms.resolver';
import {Subscription} from "rxjs";
import { stat } from 'fs';

declare var logoutCurrentUser: any;
declare var ENV_PORTAL: any;
@Component({
  selector: 'app-learn',
  templateUrl: './learndetails.component.html',
  styleUrls: ['./learndetails.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class LearnDetailsComponent implements OnInit, OnDestroy {

  id: string;
  productDetail: ProductModel;
  breadCrumbs: BreadCrumbModel[];
  pageLoader: boolean;
  user: UserProfileModel;
  permissionFlag: boolean;
  eventEmit: any;
  detailErrorMessage: String;
  pivots: Array<MobilePivotModel>;
  isFn: boolean = (ENV_PORTAL === 'fnabc') ? true : false;
  pageTitle: string;
  hasAmPermission: boolean;
  authenticationRequired: boolean;
  permissions: any;
  emailAddress: any;
  phoneNumber: any;
  initialPhoneNumber: any;
  environmentPortal: any;
  contactName: any;
  fanNumber: any;
  userFanName: any;
  currentEnrolledFan: any;
  isEnrollDisabled: boolean;
  subscriptionContent: any;
  errorMessage: any;
  detailsArray: Array<String>;
  EasyDeployArray: Array<String>;
  requirementsArray: Array<String>;
  tabsListArray: Array<String>;
  authTabsListArray: Array<String>;
  bannerButtonLabel: String;
  nextPage: String;
  fanSignUpStatus: String;
  abmflag: boolean = false;
  abmpageflag: boolean;
  ztepageflag: boolean;
  kmepageflag: boolean;
  selectedbox: boolean = false;
  fansAvailable: boolean = true;
  fivegpageflag: boolean = false;
  fivegauthpageflag: boolean = false;
  isFirstnetCustomer: boolean = false;
  isMyAttCustomer: boolean = false;
  firstnetCustomerErrormessage: any;
  firstnetCustomerErrormessage1: any;
  myAttCustomerErrormessage: any;
  myAttCustomerErrormessage1: any;
  urlLocation: any;
  show5gImage: boolean = false;
  panelOpenRemote: boolean = false;
  panelOpenTransport: boolean = false;
  panelOpenGovrmnt: boolean = false;
  panelOpenMedical: boolean = false;
  panelOpenRetail: boolean = false;
  panelOpenSales: boolean = false;
  authSubscription: boolean;
  fanInfoList: any = [];
  signupActiveFanList: any = [];
  ABMFlag: boolean = false;
  KMEFlag: boolean = false;
  ZTPFlag: boolean = false;
  DMPFlag: boolean = false;
  combinedPair: any;
  singleABMEnrolled: any = [];
  singleKMEEnrolled: any = [];
  singleZTPEnrolled: any = [];
  noOfFans: any = [];
  dmpLearnFlag: boolean = false;
  ABMActiveFans: any = [];
  eligibleFansForKME: any = [];
  eligibleFansForZTE: any = [];
  showABMEnrollLink: boolean = true;
  showKMEEnrollLink: boolean = true;
  showZTEEnrollLink: boolean = true;
  public enrollStatusSubscription: Subscription;
  detailsArrayABM: Array<String>;
  detailsArrayKME: Array<String>;
  detailsArrayZTE: Array<String>;
  filteredDetailsArrayABM: Array<String>;
  filteredDetailsArrayKME: Array<String>;
  filteredDetailsArrayZTE: Array<String>;


  UnknownMessage: String = "We are unable to access your account at this time. Please try again later.";

  constructor(private route: ActivatedRoute,
    private router: Router,
    private _sanitizer: DomSanitizer,
    private changeDetectionRef: ChangeDetectorRef,
    private utilityService: UtilityService,
    private authenticationService: AuthenticationService,
    private pageloaderService: PageLoaderService, private breadCrumbService: BreadCrumbService,
    private adobeAnalyticsService: AdobeAnalyticsService
  ) {
    this.permissionFlag = false;
    this.isEnrollDisabled = false;
    this.pageloaderService.setPageLoaderStatus(false);
    const userObj = authenticationService.getUser();
    if (userObj) {
      let userName;
      if ((userObj.firstName.length == 0 || userObj.firstName == 'NOT_FOUND') && (userObj.lastName.length == 0 || userObj.lastName == 'NOT_FOUND')) {
        userName = "Unknown";
      }
      else if ((userObj.firstName.length > 0 && userObj.firstName != 'NOT_FOUND') && (userObj.lastName.length == 0 || userObj.lastName == 'NOT_FOUND')) {
        userName = userObj.firstName;
      }
      else if ((userObj.firstName.length == 0 || userObj.firstName == 'NOT_FOUND') && (userObj.lastName.length > 0 && userObj.lastName != 'NOT_FOUND')) {
        userName = userObj.lastName;
      }
      else {
        userName = userObj.firstName + ' ' + userObj.lastName;
      }
      document.getElementsByClassName('first-name')[0].innerHTML = userName;
    }
    router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.ngOnInit();
      }
    });
    this.combinedPair = new Set();
  }

  ngOnInit() {
    let flagABMFE1;
    let flagABMFE2;
    this.id = this.route.snapshot.params['id'];
    if (this.id == 'efota') {
      this.router.navigate(['error']);
    }
    const pageData = this.route.snapshot.data.pageData;
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    const url = this.router.routerState.snapshot.url;
    const updatedUrl = url.substring(0, url.lastIndexOf('/'));
    document.title = this.utilityService.getPageTitleConfig()[updatedUrl];
    this.productDetail = new ProductModel();
    const context = window.location.pathname.split('businessconsole')[1].replace(/\//g, '');
    let respObj = pageData[context];
    this.pageloaderService.setPageLoaderStatus(true);
    this.productDetail = respObj;
    this.abmpageflag = this.productDetail.id === 'applebusinessmanager' ? true : false;
    this.ztepageflag = this.productDetail.id === 'androidzerotouch' ? true : false;
    this.kmepageflag = this.productDetail.id === 'samsungknoxmobile' ? true : false;
    this.fivegpageflag = this.productDetail.id === '5g' ? true : false;
    this.setSEO(this.productDetail.seo);
    this.productDetail.bannerName = (this.productDetail.bannerName)
      ? this.productDetail.bannerName : this.productDetail.displayName;
    this.detailsArray = this.productDetail.details;
    this.detailsArrayABM = this.productDetail.details;
    this.detailsArrayKME = this.productDetail.details;
    this.detailsArrayZTE = this.productDetail.details;
    this.EasyDeployArray = this.productDetail.EasyDeploydetails;
    this.requirementsArray = this.productDetail.requirements;
    this.tabsListArray = this.productDetail.tabsList;
    this.authTabsListArray = this.productDetail.authTabsList;
    let childUrl = '/' + this.productDetail.site;
    this.breadCrumbService.setStaticBreadCrumbs(childUrl);
    this.breadCrumbService.setCurrentBreadCrumb({
      label: this.productDetail.displayName,
      routerLink: this.router.routerState.snapshot.url
    });
    this.pageTitle = (ENV_PORTAL === 'fnabc') ? 'FirstNet Apps & Solutions ' : 'Marketplace';
    const pivots = JSON.parse(JSON.stringify(MOBILEPIVOTS.PRODDUCTDETAILSPAGE));
    this.pivots = pivots;
    this.bannerButtonLabel = this.productDetail.bannerButtonLabelInitial;
    this.fansAvailable = false;
    this.selectedbox = true;

    if (this.isLoggedIn()) {
      this.fanSignUpStatus = JSON.parse(sessionStorage.getItem('user')).user.fanSignedUpStatus;
      this.noOfFans = JSON.parse(sessionStorage.getItem('user')).user.fanList;
      this.fanInfoList = sessionStorage.getItem('fanInfoList') && sessionStorage.getItem('fanInfoList') != "undefined" ? JSON.parse(sessionStorage.getItem('fanInfoList')) : [];
      //us 4460 start
      let activeFanArr = this.fanInfoList.length > 0 ? this.fanInfoList.filter((x) => x.accountStatus === "ACTIVE" || x.accountStatus === "SIGNUP_INPROGRESS") : [];
      if (activeFanArr.length > 0) { this.fanSignUpStatus = "SOME"; }
      //end start
      const permission = JSON.parse(sessionStorage.getItem('permissions')).perm;
      this.abmflag = this.utilityService.checkComponentShowPermission("apple.productselection", permission);
      if (!this.isFullLoggedIn()) {
        this.detailErrorMessage = this.productDetail.noPermissionMessage;
        this.fansAvailable = false;
        this.selectedbox = true;
        this.utilityService.loadFocusOnTop();
        this.bannerButtonLabel = this.productDetail.bannerButtonLabelDashboard;
        this.nextPage = this.productDetail.id === 'efota' ? "dashboard/efota" : "dashboard/dep";
      } else if (this.fanSignUpStatus === 'NotEligible') {
        this.detailErrorMessage = this.productDetail.noFansMessage;
        this.utilityService.loadFocusOnTop();
        this.fansAvailable = false;
        this.selectedbox = true;
        this.bannerButtonLabel = this.productDetail.bannerButtonLabelDashboard;
        this.nextPage = "/dashboard";
      }
      // else if (this.fanSignUpStatus === 'Unknown') {
      //   this.detailErrorMessage = this.UnknownMessage;
      //   this.utilityService.loadFocusOnTop();
      //   this.fansAvailable = false;
      //   this.selectedbox = true;
      //   this.bannerButtonLabel = this.productDetail.bannerButtonLabelDashboard;
      //   this.nextPage = "/dashboard";
      // }
      else if (this.productDetail.id !== 'efota') {
        let signupActiveFanList = JSON.parse(sessionStorage.getItem('signupActiveFanList'));
        this.signupActiveFanList = signupActiveFanList && signupActiveFanList.length > 0 ? signupActiveFanList.filter((item, index) => signupActiveFanList.indexOf(item) === index) : [];
        let signupABMFanList = JSON.parse(sessionStorage.getItem('inProgressFan'));
        let fanListABMFE = signupABMFanList && signupABMFanList.length > 0 ? signupABMFanList.filter((item, index) => signupABMFanList.indexOf(item) === index) : [];

        this.signupActiveFanList = this.signupActiveFanList.concat(fanListABMFE)

        if ((this.signupActiveFanList && this.signupActiveFanList.length > 0) || (signupABMFanList && signupABMFanList.length > 0) && this.fanInfoList && this.fanInfoList.length > 0) {

          let ABMArrActiveFans = this.fanInfoList.filter(x => (x.emmProductCode === "DMPAABM" && (x.accountStatus === "ACTIVE" || x.accountStatus === "SIGNUP_INPROGRESS"))).map(x => x.fan);;
          this.ABMActiveFans = ABMArrActiveFans;
          let ABMArrEligible = this.signupActiveFanList.filter(x => ABMArrActiveFans.indexOf(x) < 0);

          let ZTPArrActiveFans = this.fanInfoList.filter(x => (x.emmProductCode === "DMPGZTP" && x.accountStatus === "ACTIVE")).map(x => x.fan);
          let KMEArrActiveFans = this.fanInfoList.filter(x => (x.emmProductCode === "DMPSKME" && x.accountStatus === "ACTIVE")).map(x => x.fan);
          let combineArr = ZTPArrActiveFans.concat(KMEArrActiveFans)
          //  let combineArr1 = ABMArrActiveFans.concat(combineArr)
          let KMEArrEligible = this.signupActiveFanList.filter(x => combineArr.indexOf(x) < 0)
          let ZTPArrEligible = this.signupActiveFanList.filter(x => ZTPArrActiveFans.indexOf(x) < 0)

          this.ABMFlag = ABMArrActiveFans.length > 0 ? true : false;
          this.KMEFlag = KMEArrActiveFans.length > 0 ? true : false;
          this.ZTPFlag = ZTPArrActiveFans.length > 0 ? true : false;
          this.DMPFlag = this.ABMFlag || this.KMEFlag || this.ZTPFlag;
          
          
          let commonABMKME = ABMArrActiveFans.filter(value => KMEArrActiveFans.includes(value));
          let commonABMZTP = ABMArrActiveFans.filter(value => ZTPArrActiveFans.includes(value));
          commonABMKME.forEach((elm) => this.combinedPair.add(elm));
          commonABMZTP.forEach((elm) => this.combinedPair.add(elm));

          //if(this.combinedPair.size > 0){
            this.singleABMEnrolled = ABMArrActiveFans.length > 0 ? ABMArrActiveFans.filter((el) => !this.combinedPair.has(el)) : [];
            this.singleKMEEnrolled = KMEArrActiveFans.length > 0 ? KMEArrActiveFans.filter((el) => !this.combinedPair.has(el)) : [];
            this.singleZTPEnrolled = ZTPArrActiveFans.length > 0 ? ZTPArrActiveFans.filter((el) => !this.combinedPair.has(el)) : [];
            this.dmpLearnFlag = this.singleABMEnrolled.length > 0 || this.singleKMEEnrolled.length > 0 || this.singleZTPEnrolled.length > 0;
          //}
          
          this.eligibleFansForKME = this.noOfFans.filter(el => !KMEArrActiveFans.includes(el));
          this.eligibleFansForZTE = this.noOfFans.filter(el => !ZTPArrActiveFans.includes(el));

        }

        if (this.productDetail.id === 'applebusinessmanager') {
          this.abmpageflag = true;
          if (this.ABMActiveFans.length == this.noOfFans.length && this.fanSignUpStatus !== 'NONE') {
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelDashboard;
            this.nextPage = "/dashboard/dep";
          }else if(this.ABMActiveFans.length < this.noOfFans.length && this.fanSignUpStatus !== 'NONE'){
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelEnroll;
            this.nextPage = "/productselection";
          }
          else if (this.fanSignUpStatus === 'NONE') {
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelEnroll;
            this.nextPage = "/welcome";
          } else {
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelEnroll;
            this.nextPage = "/productselection";
          };
        } else if (this.productDetail.id === 'samsungknoxmobile') {
          this.abmpageflag = false;
          this.ztepageflag = false;
          if (this.eligibleFansForKME.length > 0 && this.fanSignUpStatus !== 'NONE') {
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelEnroll;
            this.nextPage = "/productselection";
          } 
          // else if (activeFanArr.length == 1 && this.ZTPFlag && this.fanSignUpStatus !== 'NONE') {
          //   this.bannerButtonLabel = this.productDetail.bannerButtonLabelDashboard;
          //   this.nextPage = "/dashboard/dep";
          // }
          else if (this.fanSignUpStatus === 'NONE') {
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelEnroll;
            this.nextPage = "/welcome";
          } else {
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelDashboard;
            this.nextPage = "/dashboard/dep";
          };
        } else if (this.productDetail.id === 'androidzerotouch') {
          this.abmpageflag = false;
          this.kmepageflag = false;
          if (this.eligibleFansForZTE.length > 0 && this.fanSignUpStatus !== 'NONE') {
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelEnroll;
            this.nextPage = "/productselection";
          } 
          // else if (activeFanArr.length == 1 && this.KMEFlag && this.fanSignUpStatus !== 'NONE') {
          //   this.bannerButtonLabel = this.productDetail.bannerButtonLabelDashboard;
          //   this.nextPage = "/dashboard/dep";
          // }
          else if (this.fanSignUpStatus === 'NONE') {
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelEnroll;
            this.nextPage = "/welcome";
          } else {
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelDashboard;
            this.nextPage = "/dashboard/dep";
          };
        } else if (this.productDetail.id === 'products') {
          //this.bannerButtonLabel =  this.productDetail.bannerButtonLabelEnroll;
          //this.nextPage = "/productselection";
          console.log("this.combinedPair===>", this.combinedPair);
          if (this.combinedPair.size < this.noOfFans.length && this.fanSignUpStatus !== 'NONE') {
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelEnroll;
            this.nextPage = "/productselection";
          } 
          // else if (this.KMEFlag && this.fanSignUpStatus !== 'NONE') {
          //   this.bannerButtonLabel = this.productDetail.bannerButtonLabelDashboard;
          //   this.nextPage = "/dashboard/dep";
          // }
          else if (this.fanSignUpStatus === 'NONE') {
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelEnroll;
            this.nextPage = "/welcome";
          } else {
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelDashboard;
            this.nextPage = "/dashboard/dep";
          };
        } else if (this.productDetail.id === '5g') {         
          this.fivegauthpageflag = true;
          this.show5gImage = true;
          this.urlLocation = location.href;

          if (ENV_PORTAL === 'fnabc') {
            this.isFirstnetCustomer = true;
            this.firstnetCustomerErrormessage = this.productDetail.firstNetErrorMessagefirstPart;
            this.firstnetCustomerErrormessage1 = this.productDetail.firstNetErrorMessageSecondPart;
            this.bannerButtonLabel = this.productDetail.bannerButtonLabelDashboard;
            this.nextPage = "/dashboard/dep";  
          } 
          else if(ENV_PORTAL === 'myatt') {
            this.isMyAttCustomer = true;
            this.myAttCustomerErrormessage = this.productDetail.myAttErrorMessageFirstPart;
            this.myAttCustomerErrormessage1 = this.productDetail.myAttErrorMessageSecondPart;
          }
          else {
            this.bannerButtonLabel = this.productDetail.bannerButtonAuthLabel;
            this.nextPage = "/fiveg/enrollment";
          }
        }
      }
      else if (!this.isLoggedIn()) {
        this.bannerButtonLabel = this.productDetail.bannerButtonLabelInitial;
        this.fansAvailable = false;
        this.selectedbox = true;
      }
    }else{
      if (this.productDetail.id === '5g') {
        if(location.href.includes('firstnet')) {
          this.isFirstnetCustomer = true;
          this.firstnetCustomerErrormessage = this.productDetail.firstNetErrorMessagefirstPart;
          this.firstnetCustomerErrormessage1 = this.productDetail.firstNetErrorMessageSecondPart;
        }else if(location.href.includes('stage')){
          this.isMyAttCustomer = true;
          this.myAttCustomerErrormessage = this.productDetail.myAttErrorMessageFirstPart;
          this.myAttCustomerErrormessage1 = this.productDetail.myAttErrorMessageSecondPart;
        }else{
          this.isFirstnetCustomer = false;
          this.isMyAttCustomer = false;
        }
      }
    }  
    sessionStorage.setItem('selectedProd', this.productDetail.id);
    this.enrollStatusSubscription = this.authenticationService.getEnrollStatus().subscribe(status => {
      console.log("Enroll Status: " + status);
      this.showABMEnrollLink = status;   
      this.showZTEEnrollLink = status;
      this.showKMEEnrollLink = status;
    });

    this.filterDetailsArrayABM();
    this.filterDetailsArrayZTE();
    this.filterDetailsArrayKME();
    
  }

  filterDetailsArrayABM() {
    if (this.productDetail.id === 'applebusinessmanager' && !this.showABMEnrollLink) {
      this.filteredDetailsArrayABM = this.detailsArrayABM.filter((_, index) => index !== 0 );
    } else {
      this.filteredDetailsArrayABM = this.detailsArrayABM.filter((_, index) => index !== 1 );
    }
  }

  filterDetailsArrayKME() {
    if (this.productDetail.id === 'samsungknoxmobile' && !this.showKMEEnrollLink) {
      this.filteredDetailsArrayKME = this.detailsArrayKME.filter((_, index) => index !== 3 );
    } else if (this.productDetail.id === 'applebusinessmanager') {
      this.filterDetailsArrayABM();
    } else if (this.productDetail.id === 'andoidzerotouch') {
      this.filterDetailsArrayZTE();
    } else {
      this.filteredDetailsArrayKME = this.detailsArrayKME.filter((_, index) => index !== 4 );
    }
  }

  // filterDetailsArrayKME() {
  //   if (this.productDetail.id === 'samsungknoxmobile' && !this.showKMEEnrollLink) {
  //     this.filteredDetailsArrayKME = this.detailsArrayKME.filter((_, index) => index !== 3 );
  //   } else {
  //     this.filteredDetailsArrayKME = this.detailsArrayKME.filter((_, index) => index !== 4 );
  //   }
  // }

  filterDetailsArrayZTE() {
    if (this.productDetail.id === 'androidzerotouch' && !this.showZTEEnrollLink) {
      this.filteredDetailsArrayZTE = this.detailsArrayZTE.filter((_, index) => index !== 0 );
    } else {
      this.filteredDetailsArrayZTE = this.detailsArrayZTE.filter((_, index) => index !== 1 );
    }
  }
  
  ngAfterViewChecked() {
    let backToLearnFlag = sessionStorage.getItem('backToLearn');
    if (backToLearnFlag == "true") {
      let element = document.getElementById("subscriptionContent");
      element.scrollIntoView();
      sessionStorage.setItem('backToLearn', 'false');
    }
  }

  isFullLoggedIn() {
    return (sessionStorage.getItem('user') && (JSON.parse(sessionStorage.getItem('user')).user.addpAuthority == 'FULL')) ? true : false;
  }

  isNotFullLoggedIn() {
    return (sessionStorage.getItem('user') && (JSON.parse(sessionStorage.getItem('user')).user.addpAuthority != 'FULL')) ? true : false;
  }

  isLoggedIn() {
    return sessionStorage.getItem('user') ? true : false;
  }

  setSEO(seo: SEO) {
    if (!seo) return;
    if (seo.title) document.title = seo.title;
    if (seo.description)
      document.getElementsByTagName('meta')['description'].content = seo.description;
  }

  next() {
    if (this.authenticationService.getUser() === null) {
      this.authenticationService.setLoginSuccessUrl('/learn/' + this.productDetail.id);
      // this.router.navigate(['login']);
      this.authenticationService.setLoginModalStatus(true);
    } else {
      if (this.productDetail.id === 'applebusinessmanager') {
        if (this.abmflag) {
          this.router.navigate([this.nextPage]);
        } else {
          this.detailErrorMessage = this.productDetail.noCIPermissionMessage;
        }
      } else {
        this.router.navigate([this.productDetail.id === '5g' ? "/fiveg/enrollment" : this.nextPage]);
      }
    }
  }

  tabClick(tab) {
    if (tab === 'Details') {
      if (this.fivegauthpageflag) {
        let el = <HTMLElement>document.querySelector(" [id='subscriptionsection']");
        el.scrollIntoView();
      } else {
        let el = <HTMLElement>document.querySelector(" [id='details']");
        el.scrollIntoView();
      }
    }
    else if (tab === "Getting Started") {
      let el = <HTMLElement>document.querySelector(" [id='GettingStarted']");
      el.scrollIntoView();
    }
    else if (tab === 'Easy to Deploy & Manage') {
      let el = <HTMLElement>document.querySelector(" [id='easyDeployDetails']");
      el.scrollIntoView();
    }
    else if (tab === '5G Private Routing FAQ') {

    }
    else if (tab === 'Use Cases') {
      let el = <HTMLElement>document.querySelector(" [id='usecases-section']");
      el.scrollIntoView();
    }
    else if (tab === 'Eligibility') {
      let el = <HTMLElement>document.querySelector(" [id='details']");
      el.scrollIntoView();
    } else if (tab === 'System requirements') {
      let el = <HTMLElement>document.querySelector(" [id='SystemRequirements']");
      el.scrollIntoView();
    }
  }

  pageNavigate() {
    if (this.authenticationService.getUser() !== null) {
      this.authenticationService.setLoginSuccessUrl('/productConfigurator/' + this.productDetail.id);
      window.location.href = '/businessconsole/login';
    } else {
      this.router.navigate(['productConfigurator/' + this.productDetail.id]);
    }
  }

  pageLoadEvent(boolValue: boolean) {
    this.pageloaderService.setPageLoaderStatus(boolValue);
  }
  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
  reset() {
    sessionStorage.clear();
  }

  changeEvent($event) {
    if (this.fanSignUpStatus === 'ALL') {
      this.fansAvailable = false;
    }

    if ($event.target.checked) {
      this.selectedbox = true;
    }
    else {
      this.selectedbox = false;
    }
  }

  scrollUp() {
    this.utilityService.loadFocusOnTop();
  }

  toggleTooltip(event) {
    const targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

}
